export default "__VITE_ASSET__r7PQdjj$__"